import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, Transition as _Transition, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = { class: "sidebar-layout is-dark" }
const _hoisted_2 = {
  key: 0,
  class: "app-overlay"
}
const _hoisted_3 = { class: "brand-end" }
const _hoisted_4 = { class: "view-wrapper" }
const _hoisted_5 = { class: "page-content-wrapper" }
const _hoisted_6 = {
  key: 1,
  class: "page-content is-relative"
}
const _hoisted_7 = { class: "page-title has-text-centered" }
const _hoisted_8 = { class: "menu-toggle has-chevron" }
const _hoisted_9 = { class: "title-wrap" }

import {ref, watchPostEffect, watch,PropType} from 'vue'
import {useRoute} from 'vue-router'
import AnimatedLogo from '../components/partials/AnimatedLogo.vue'
import {activePanel} from './../state/activePanelState'
import {pageTitle} from './../state/sidebarLayoutState'
import { computed } from "vue";
import { mapState } from "vuex";

import MobileNavbar from '../components/navigation/mobile/MobileNavbar.vue'
import MobileSidebar from '../components/navigation/mobile/MobileSidebar.vue'
import Sidebar from '../components/navigation/desktop/Sidebar.vue'
import UserProfileDropdown from "../components/partials/dropdowns/UserProfileDropdown.vue";
import DashboardsMobileSubsidebar from '../layouts/mobile-subsidebars/DashboardsMobileSubsidebar.vue'
import DashboardsSubsidebar from '../layouts/sidebar-subsidebar/DashboardsSubsidebar.vue'
import Toolbar from '../components/partials/toolbars/Toolbar.vue'
type SidebarTheme =
    | 'default'
    | 'color'
    | 'color-curved'
    | 'curved'
    | 'float'
    | 'labels'
    | 'labels-hover'


export default /*@__PURE__*/_defineComponent({
  __name: 'SidebarLayout',
  props: {
  theme: {
    type: String as PropType<SidebarTheme>,
    default: 'default',
  },
  defaultSidebar: {
    type: String,
    default: 'dashboard',
  },
  closeOnChange: {
    type: Boolean,
    default: false,
  },
  openOnMounted: {
    type: Boolean,
    default: false,
  },
  nowrap: {
    type: Boolean,
    default: false,
  },
},
  setup(__props) {

const props = __props

const user = computed(()=>{
  return mapState(['user'])
});

const route = useRoute()
const isMobileSidebarOpen = ref(false)
const isDesktopSidebarOpen = ref(props.openOnMounted)
const activeMobileSubsidebar = ref(props.defaultSidebar)


function switchSidebar(id: string) {
  if (id === activeMobileSubsidebar.value) {
    isDesktopSidebarOpen.value = !isDesktopSidebarOpen.value
  } else {
    isDesktopSidebarOpen.value = true
    activeMobileSubsidebar.value = id
  }
}

/**
 * watchPostEffect callback will be executed each time dependent reactive values has changed
 */
watchPostEffect(() => {
  const isOpen = isDesktopSidebarOpen.value
  const wrappers = document.querySelectorAll('.view-wrapper')

  wrappers.forEach((wrapper) => {
    if (isOpen === false) {
      wrapper.classList.remove('is-pushed-full')
    } else if (!wrapper.classList.contains('is-pushed-full')) {
      wrapper.classList.add('is-pushed-full')
    }
  })
})
watch(
    () => route.fullPath,
    () => {
      isMobileSidebarOpen.value = false

      if (props.closeOnChange && isDesktopSidebarOpen.value) {
        isDesktopSidebarOpen.value = false
      }
    }
)

return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (user.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2))
      : _createCommentVNode("", true),
    _createVNode(MobileNavbar, {
      "is-open": isMobileSidebarOpen.value,
      onToggle: _cache[0] || (_cache[0] = ($event: any) => (isMobileSidebarOpen.value = !isMobileSidebarOpen.value))
    }, {
      brand: _withCtx(() => [
        _createVNode(_component_RouterLink, {
          to: { name: 'Index' },
          class: "navbar-item is-brand"
        }, {
          default: _withCtx(() => [
            _createVNode(AnimatedLogo, {
              width: "38px",
              height: "38px"
            })
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(UserProfileDropdown)
        ])
      ]),
      _: 1
    }, 8, ["is-open"]),
    _createVNode(MobileSidebar, {
      "is-open": isMobileSidebarOpen.value,
      onToggle: _cache[2] || (_cache[2] = ($event: any) => (isMobileSidebarOpen.value = !isMobileSidebarOpen.value))
    }, {
      links: _withCtx(() => [
        _createElementVNode("li", null, [
          _createElementVNode("a", {
            class: _normalizeClass([activeMobileSubsidebar.value === 'dashboard' && 'is-active']),
            onClick: _cache[1] || (_cache[1] = ($event: any) => (activeMobileSubsidebar.value = 'dashboard'))
          }, [...(_cache[6] || (_cache[6] = [
            _createElementVNode("i", {
              "aria-hidden": "true",
              class: "iconify",
              "data-icon": "feather:activity"
            }, null, -1)
          ]))], 2)
        ])
      ]),
      _: 1
    }, 8, ["is-open"]),
    _createVNode(_Transition, { name: "slide-x" }, {
      default: _withCtx(() => [
        (
          isMobileSidebarOpen.value && activeMobileSubsidebar.value === 'dashboard'
        )
          ? (_openBlock(), _createBlock(DashboardsMobileSubsidebar, { key: 0 }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(Sidebar, {
      theme: props.theme,
      "is-open": isDesktopSidebarOpen.value
    }, {
      links: _withCtx(() => [
        _createElementVNode("li", null, [
          _createElementVNode("a", {
            class: _normalizeClass([activeMobileSubsidebar.value === 'dashboard' && 'is-active']),
            "data-content": "Dashboards",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (switchSidebar('dashboard')))
          }, [...(_cache[7] || (_cache[7] = [
            _createElementVNode("i", {
              "aria-hidden": "true",
              class: "iconify sidebar-svg",
              "data-icon": "feather:activity"
            }, null, -1)
          ]))], 2)
        ])
      ]),
      "bottom-links": _withCtx(() => [
        _createElementVNode("li", null, [
          _createVNode(UserProfileDropdown, { up: "" })
        ])
      ]),
      _: 1
    }, 8, ["theme", "is-open"]),
    _createVNode(_Transition, { name: "slide-x" }, {
      default: _withCtx(() => [
        (
          isDesktopSidebarOpen.value && activeMobileSubsidebar.value === 'dashboard'
        )
          ? (_openBlock(), _createBlock(DashboardsSubsidebar, {
              key: 0,
              onClose: _cache[4] || (_cache[4] = ($event: any) => (isDesktopSidebarOpen.value = false))
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        (props.nowrap)
          ? _renderSlot(_ctx.$slots, "default", { key: 0 })
          : (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                (user.value)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: "vuero-hamburger nav-trigger push-resize",
                      onClick: _cache[5] || (_cache[5] = ($event: any) => (isDesktopSidebarOpen.value = !isDesktopSidebarOpen.value))
                    }, [
                      _createElementVNode("span", _hoisted_8, [
                        _createElementVNode("span", {
                          class: _normalizeClass([[isDesktopSidebarOpen.value && 'active'], "icon-box-toggle"])
                        }, [...(_cache[8] || (_cache[8] = [
                          _createElementVNode("span", { class: "rotate" }, [
                            _createElementVNode("i", {
                              "aria-hidden": "true",
                              class: "icon-line-top"
                            }),
                            _createElementVNode("i", {
                              "aria-hidden": "true",
                              class: "icon-line-center"
                            }),
                            _createElementVNode("i", {
                              "aria-hidden": "true",
                              class: "icon-line-bottom"
                            })
                          ], -1)
                        ]))], 2)
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_9, [
                  _createVNode(_component_RouterLink, { to: { name: 'Index' } }, {
                    default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                      _createElementVNode("img", {
                        src: "/images/logos/logo/logo-brand.gif",
                        alt: ""
                      }, null, -1)
                    ]))]),
                    _: 1
                  })
                ])
              ]),
              _renderSlot(_ctx.$slots, "default")
            ]))
      ])
    ])
  ]))
}
}

})